/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { Text, Pane, Flex, Button, Label, PortalOverlay, CompositeTextInput, Toast, TextArea } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { PuffLoader } from 'react-spinners';
import { GlobalState } from '@leverege/ui-redux';
import classes from './Classes.css';

// eslint-disable-next-line no-unused-vars
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovrGeneric.ownershipTransfer');
export default function InitiateTransferView(props) {
  const {
    onClose,
    reloadData,
    devices,
    objectType
  } = props;
  const clientHost = `${window.location.protocol}//${window.location.host}`;
  const uiName = process.env.UI_NAME;
  const deviceIds = devices.map(device => device.id);
  const systemId = devices[0].systemId;
  // const projectId = devices[0].projectId
  const locationId = devices[0].data?.location?.id;
  const companyId = devices[0].data?.company?.id;
  const orgId = devices[0].data?.organization?.id;
  const singularDeviceTerm = objectType === 'locator' ? 'Locator' : 'Equipment';
  const pluralDeviceTerm = objectType === 'locator' ? 'Locators' : 'Equipments';
  let deviceTerm;
  if (devices.length === 1) {
    deviceTerm = devices[0].name;
  } else {
    deviceTerm = `${devices.length} ${pluralDeviceTerm}`;
  }

  // const assetIndustryName = t( `assetIndustryName.${uiName}`, 'Asset' )

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState();
  const [accountExists, setAccountExists] = useState(false);
  const [accountUsername, setAccountUsername] = useState();
  const [accountUser, setAccountUser] = useState();
  const [additionalMessage, setAdditionalMessage] = useState();
  const [assetLocation, setAssetLocation] = useState();
  useEffect(() => {
    GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      try {
        const state = getState();
        let location = state?.models?.lookup?.[locationId];
        if (!location) {
          if (orgId) {
            location = await api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).get();
          } else {
            location = await api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).get();
          }
        }
        setAssetLocation(location);
      } catch (error) {
        Toast.error(`Error in fetching ${singularDeviceTerm} data`);
      }
    });
  });
  const isValid = !error && !loading && !submitted && accountExists;
  const onChangeExAcctEmail = async event => {
    setError(null);
    let {
      value
    } = event;
    value = value?.trim() || value;
    setAccountUsername(value);
    setAccountUser(null);
    if (!value) {
      setAccountExists(false);
      return;
    }
    setLoading(true);
    GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      try {
        const usersByUsername = await api.project(api.options.projectId).accounts().list({
          username: value
        });
        if (usersByUsername?.items?.length === 1) {
          const user = usersByUsername?.items?.[0];
          setAccountUser(user);
        } else if (usersByUsername?.items?.length > 1) {
          throw new Error('Multiple users found for username');
        } else {
          throw new Error(`User ${value} not found`);
        }
        setAccountExists(true);
      } catch (err) {
        // error the form
        setError(err);
        setAccountExists(false);
        setAccountUser(null);
      } finally {
        setLoading(false);
      }
    });
  };
  const onSubmit = evt => {
    try {
      setSubmitted(true);
      GlobalState.dispatch(async (dispatch, getState, {
        api
      }) => {
        try {
          const state = getState();
          const {
            auth
          } = state;
          const sellerName = auth?.profile?.name;
          const transferData = {
            buyerUser: accountUser,
            sellerName,
            additionalMessage
          };
          let res;
          if (orgId) {
            res = await api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).srv('ownershipTransfer').post('initiateBulkTransfer', {
              deviceIds,
              locationId,
              companyId,
              deviceAlias: objectType,
              clientHost,
              uiName,
              transferData
            });
          } else {
            res = await api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).srv('ownershipTransfer').post('initiateBulkTransfer', {
              deviceIds,
              locationId,
              companyId,
              deviceAlias: objectType,
              clientHost,
              uiName,
              transferData
            });
          }
          if (res.status !== 500) {
            setTimeout(async () => {
              await reloadData();
            }, 2000);
            Toast.success(`${singularDeviceTerm} Transfer initiated`);
          } else {
            Toast.error(`Error initiating ${singularDeviceTerm} Transfer`);
          }
        } catch (error) {
          Toast.error(`Error initiating ${singularDeviceTerm} Transfer`);
        }
      });
    } catch (err) {
      Toast.error(`Error initiating ${singularDeviceTerm} Transfer`);
    } finally {
      onClose(evt);
    }
  };
  let icon;
  if (loading) {
    icon = /*#__PURE__*/_jsx(PuffLoader, {
      size: 24
    });
  } else if (error) {
    icon = /*#__PURE__*/_jsx("img", {
      className: classes.icon,
      src: "https://recovr-ui-assets.storage.googleapis.com/system-fail-icon.svg",
      alt: "user icon"
    });
  } else if (!accountUsername) {
    icon = /*#__PURE__*/_jsx("img", {
      className: classes.icon,
      src: "https://recovr-ui-assets.storage.googleapis.com/user.png",
      alt: "user icon"
    });
  } else if (accountExists) {
    icon = /*#__PURE__*/_jsx("img", {
      className: classes.icon,
      src: "https://recovr-ui-assets.storage.googleapis.com/system-success-icon.svg",
      alt: "user icon"
    });
  }
  const iconBackgroundStyle = {
    height: '24px',
    width: '24px',
    borderRadius: '2px',
    backgroundColor: '#F0F6FF',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  };
  const iconStyle = {
    color: '#1646C5',
    position: 'absolute',
    align: 'center'
  };
  const renderForm = () => /*#__PURE__*/_jsxs(Pane, {
    variant: "editorDialog",
    className: classes.dialog,
    children: [/*#__PURE__*/_jsxs(Flex, {
      className: classes.dialogHeader,
      justify: "space-between",
      children: [/*#__PURE__*/_jsx(Text, {
        style: {
          fontWeight: 'bold'
        },
        icon: /*#__PURE__*/_jsx(Flex, {
          style: {
            ...iconBackgroundStyle
          },
          children: /*#__PURE__*/_jsx("img", {
            src: "https://storage.googleapis.com/prd-generic-kudelski-ui-assets/Screen%20Icons/screen-transfers-blue.svg",
            alt: "Transfer Icon",
            style: {
              ...iconStyle
            }
          })
        }),
        children: "Transfer Ownership"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "closeWindow",
        icon: "fa fa-remove",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(Pane, {
      className: classes.dialogBody,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "col",
        justify: "space-between",
        children: [/*#__PURE__*/_jsxs(Text, {
          variant: "bodySmall",
          style: {
            lineHeight: '26px',
            fontSize: '16px'
          },
          children: ["Transfer ", /*#__PURE__*/_jsx("b", {
            children: deviceTerm
          }), " to another location outside of ", /*#__PURE__*/_jsx("b", {
            children: assetLocation?.name
          }), ". The Buyer will get an email to accept or reject ", /*#__PURE__*/_jsx("b", {
            children: deviceTerm
          }), ", along with its associated data. You\u2019ll be informed of their decision. Transaction details are available in the transfers tab."]
        }), /*#__PURE__*/_jsx(Label, {
          style: {
            paddingTop: '16px',
            paddingBottom: '4px',
            size: '13px'
          },
          children: " Buyer Username "
        }), /*#__PURE__*/_jsx(CompositeTextInput, {
          variant: "salesFlowCustomerLookup",
          name: "buyerUsername",
          pre: icon,
          style: {
            height: '40px',
            width: '408px'
          },
          eventData: "exAcctEmail",
          onChange: onChangeExAcctEmail,
          value: accountUsername
        }), /*#__PURE__*/_jsx(Text, {
          style: {
            fontSize: '13px',
            color: '#67798E'
          },
          children: " Enter the buyer's RecovR username "
        }), /*#__PURE__*/_jsx(Label, {
          style: {
            paddingTop: '16px',
            paddingBottom: '4px',
            size: '13px'
          },
          children: " Additional Message to Buyer "
        }), /*#__PURE__*/_jsx(TextArea, {
          style: {
            height: '104px',
            width: '448px',
            resize: 'none'
          },
          name: "additionalMessage",
          value: additionalMessage,
          onChange: newValObject => {
            const newVal = newValObject?.value;
            setAdditionalMessage(newVal);
          },
          className: classes.formInput
        }), /*#__PURE__*/_jsx(Text, {
          style: {
            fontSize: '13px',
            color: '#67798E'
          },
          children: " Optional: Add a message for the buyer "
        })]
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowL",
      className: classes.dialogFooter,
      justify: "flex-end",
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        className: classes.button,
        onClick: onClose,
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        disabled: !isValid,
        variant: "submit",
        onClick: onSubmit,
        children: "Initiate Transfer"
      })]
    })]
  });
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: "center",
    show: true,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    children: renderForm()
  });
}